import { MdInfo } from 'react-icons/md'
import { Parser } from 'html-to-react'
import Dialog from '../../../../../components/Dialog/Dialog'
import DownloadPDFWithFetch from '../../../../../components/DownloadPDF/DownloadPDFWithFetch'

interface IMethodologyNoteDialog {
    isOpen: boolean,
    toggle: () => void,
    notas: string,
    documento_informativo: string
}

const MethodologyNoteDialog = ({ isOpen, toggle, notas, documento_informativo }: IMethodologyNoteDialog) => {

    return (
        <Dialog isOpen={isOpen} toggle={toggle} bgColor="bg-brand-green-5">
            <div className='flex gap-3 flex-col'>
                <div className='flex flex-col items-center'>
                    <MdInfo size={22} color='#205253' />
                    <p className='text-hsmall text-system-light-100'>Nota metodológica</p>
                </div>
                <div className='text-bmedium text-system-light-40'>{Parser().parse(notas)}</div>
                {documento_informativo && documento_informativo.trim() !== '' && (
                    <>
                        <span className='text-bmedium text-primary-40'>
                            ¿Querés conocer más sobre esta metodología?, hacé click en el siguiente botón.
                        </span>
                        <div className='flex items-center justify-center'>
                            <DownloadPDFWithFetch
                                fileName={documento_informativo}
                                label='Descargar PDF'
                                variant='terciary'
                                source='Nota metodológica'
                                module='Visualizador de indicadores'
                                icon={null}
                            />
                        </div>
                    </>
                )}
            </div>
        </Dialog>
    )
}

export default MethodologyNoteDialog